import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

import { EffectFade } from 'swiper';

// import Swiper styles
import 'swiper/css';

//import 'swiper/css/effect-fade';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

class Slider {
  static init() {
    this.introSlider();
    this.marque1Slider();
    this.marque2Slider();
    this.reloadSlider();

     if (window.innerWidth < 1200) {
       this.navTabsSlider();
     }
  }

  static introSlider() {
    const swiperSlider = new Swiper(
      '.intro .swiper-container',
      {

        spaceBetween: 0,
        centeredSlides: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: false,
        slidesPerView: 1,
        pagination: {
          el: ".slider-pagination",
          clickable: true,
        },
      }
    );
  }

  static marque1Slider() {
    const swiperMarques = new Swiper(
      '.univers #marques1 .swiper-container',
      {

        spaceBetween: 57,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
          delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 35,
          },
          1500: {
            slidesPerView: 8,
            spaceBetween: 55,
          },
        },
      }
    );
  }
  static marque2Slider() {
    const swiperMarques2 = new Swiper(
      '.univers #marques2 .swiper-container',
      {

        spaceBetween: 57,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
          delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 35,
          },
          1500: {
            slidesPerView: 8,
            spaceBetween: 55,
          },
        },
      }
    );
  }
  static navTabsSlider() {
    const swiperTabs = new Swiper(
      '.univers .tabs-link-mobile',
      {
        slidesPerView: 1.4,
        spaceBetween: 0,
        grabCursor: true,
        allowTouchMove: true,
        centeredSlides: false,
        on: {
          afterInit: () => {
            let tabsImg = document.querySelectorAll('.img-magasin');

            tabsImg.forEach((el) => {
              el.addEventListener('click', function(e) {
                e.target.classList.forEach((name) => {

                  if(name.indexOf('tab') == 0) {
                    let id = name.replace( /^\D+/g, '')

                    if( id == 1 ){
                      swiperTabs.slideTo(0)
                    }
                    else if (id == 2 ) {
                      swiperTabs.slideTo(1)
                    }
                    else {
                      swiperTabs.slideTo(2)
                    }
                  }
                })
              })
            });
          }
        }
      }
    );

    swiperTabs.on('slideChange', function () {
      let tabsImg = document.querySelectorAll('.img-magasin');
      let navItem = document.querySelectorAll('.tabs-link-mobile .nav-item');
      let sliderMarque1 = document.querySelector('#marques1');
      let sliderMarque2 = document.querySelector('#marques2');
      let activeTabs = swiperTabs.activeIndex;
    });
  }

  static reloadSlider() {
    let slider = document.querySelector('#marques1');
    let itemSlide = document.querySelectorAll('.nav-item.swiper-slide');
    itemSlide.forEach((el) => {
      el.addEventListener('click', function(e) {
        if (slider?.classList.contains('active')) {
          Slider.marque1Slider()
        }
      })
    });
  }
}

export default Slider;
